// extracted by mini-css-extract-plugin
export var divider = "_lt-0";
export var systemMessage = "_lt-1";